import { graphql } from '@/generated/gql';

export const USER_PROFILE_MUTATION = graphql(/* GraphQL */ `
  mutation UpdateUserProfile($userId: UUID, $data: AstroUserProfileInput!) {
    astronaut {
      user(id: $userId) {
        profile {
          update(data: $data) {
            id
            firstName
            lastName
            email
            capabilityIds
            commodityGroupIds
            workingHours
            deliveryLocationId
            organizationId
            accountingAreaId
            costCenterId
            currency
            jobTitle
            pictureId
            updatedAt
            createdAt
          }
        }
      }
    }
  }
`);
